module.exports = __webpack_public_path__ + "img/active-6.654d4896.svg";